import { useEffect } from "react";
import { isFeishuEnv, getStoredFeishuOrgId } from "@/utils/feishu";

/**
 * 未登录访问需登录页面时的统一跳转（与历史 Navbar 行为一致）。
 * 需在 App 的 SignedOut 路由中使用：隐藏导航栏的页面无法依赖 Navbar 内的跳转。
 */
export default function SignedOutRedirectToLogin() {
  useEffect(() => {
    const thisPageUrl = window.location.href;

    if (isFeishuEnv()) {
      const orgId =
        new URLSearchParams(window.location.search).get("orgId") ||
        getStoredFeishuOrgId();
      if (orgId) {
        const query = new URLSearchParams({ orgId });
        const pathname = window.location.pathname;
        if (pathname && pathname !== "/") {
          query.set("returnTo", pathname + window.location.search);
        }
        window.location.href = `/feishu-login?${query.toString()}`;
        return;
      }
    }

    if (
      thisPageUrl.includes("organization") ||
      thisPageUrl.includes("login") ||
      thisPageUrl.includes("signup") ||
      thisPageUrl.includes("share") ||
      thisPageUrl.includes("feishu-login")
    ) {
      return;
    }
    const redirectUrl = thisPageUrl.replace("organization", "");
    window.location.href = "/login?redirect_url=" + redirectUrl;
  }, []);

  return null;
}
